import { createElement } from 'react'
import { workspaceIconLabel } from '@/services/workspaces/workspacePresets'
import { workspaceIconComponent } from '@/services/workspaces/workspaceIconMap'
import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspaceIconOption({ id, selected, onSelect }) {
  return (
    <button
      type="button"
      role="option"
      aria-label={workspaceIconLabel(id)}
      aria-selected={selected}
      className={styles.iconOption}
      onClick={() => onSelect(id)}
    >
      {createElement(workspaceIconComponent(id, 24), { 'aria-hidden': true })}
    </button>
  )
}
